import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import type { DriveUnitPortOccupancy } from '../../../redux/ApplicationSlice';
import type { DrawerCollapsibleWidget, DrawerMetricCollapsibleGroup } from '../../../utils/electronicsDashboardUtils';
import DraggableComponent from '../DraggableComponent';
import CollapsibleDraggableData from './CollapsibleDraggableData';

export type { DrawerCollapsibleWidget, DrawerMetricCollapsibleGroup };

export type MotorDrawerSectionProps = {
  motorPorts: DriveUnitPortOccupancy[];
  projectCode: string;
};

export type SensorDrawerSectionProps = {
  sensorPorts: DriveUnitPortOccupancy[];
  projectCode: string;
};

/** Shared vertical spacing for motor-data drawer subsections. */
export const DrawerSectionStack = ({ children }: { children: ReactNode }) => (
  <Stack alignItems="center" spacing={1} sx={{ width: '100%', pt: 0.5 }}>
    {children}
  </Stack>
);

/** Aligns a flat draggable row with {@link CollapsibleDraggableData} expand-button width. */
export const AlignedDraggableRow = ({ widget }: { widget: DrawerCollapsibleWidget }) => (
  <Stack direction="row" alignItems="center">
    <DraggableComponent
      id={widget.id}
      type={widget.type}
      dataKey={widget.dataKey}
      title={widget.title}
      minH={widget.minH}
      minW={widget.minW}
      options={widget.options}
      sx={{ m: 0 }}
    />
    <IconButton sx={{ visibility: 'hidden', p: 0 }} tabIndex={-1} aria-hidden>
      <ExpandMoreIcon />
    </IconButton>
  </Stack>
);

export const MetricCollapsibleDrawerSection = ({ groups }: { groups: DrawerMetricCollapsibleGroup[] }) => {
  if (groups.length === 0) {
    return null;
  }

  return (
    <DrawerSectionStack>
      {groups.map((group) => (
        <CollapsibleDraggableData key={group.groupKey ?? group.metric} data={group.data} />
      ))}
    </DrawerSectionStack>
  );
};
